import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { ThemeProvider } from '@pray/shared/contexts';
import logger from '@pray/shared/utils/logger';

import { SolomonPanelProvider, SolomonPanel } from 'components/global/SolomonPanel';
import { FEATURE_FLAG_IDS } from 'constants.js';
import FeatureFlagProvider from 'context/FeatureFlagContext';
import StudioContextProvider from 'context/StudioContext';
import { bootScenarioLayer } from 'dev/scenarioLayer';

import App from './App';

import '@pray/shared/styles/normalize.css';
import '@pray/shared/styles/global.css';

import './styles/app.scss';
import './styles/globals.css';

export const rootSelector = '#root';

const root = ReactDOM.createRoot(document.querySelector(rootSelector)!);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

const render = () =>
  root.render(
  <QueryClientProvider client={queryClient}>
    <ThemeProvider defaultTheme={{ colorMode: 'light', variant: 'studio' }}>
      <StudioContextProvider>
        <FeatureFlagProvider
          flagIds={[
            'impact-reports',
            'solomon-agent',
            'superfunnel-analytics',
            'payback-period-chart',
            'revenue-calculator',
            'studio-ai-chat',
            'studio-push',
            'superfunnel-self-serve',
            FEATURE_FLAG_IDS.PRAY_TV_SCHEDULING,
            FEATURE_FLAG_IDS.PRAY_RADIO_SCHEDULING,
            FEATURE_FLAG_IDS.YOUTUBE_PLAYLIST_IMPORT,
            FEATURE_FLAG_IDS.LIBRARY_ARTICLES,
          ]}
        >
          <SolomonPanelProvider>
            <App />
            <SolomonPanel />
          </SolomonPanelProvider>
        </FeatureFlagProvider>
      </StudioContextProvider>
    </ThemeProvider>
  </QueryClientProvider>
  );

// A preview URL installs its scenario before the first request; every other URL renders at once.
bootScenarioLayer(window.location.pathname)
  .catch((error) => logger.error('Could not load the preview scenario', error))
  .then(render);
// build: 20260404045936
